import { type EditorPlugin } from '../../../types/aha-editor';
import CodeSnippet from './components/CodeSnippet';

const CodeSnippetComponentPlugin: EditorPlugin = {
  name: 'Code snippet component plugin',
  component: {
    type: 'code-snippet',
    component: CodeSnippet,
  },
};

export default CodeSnippetComponentPlugin;
